import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import Image from "react-bootstrap/Image";

import { BrandName, TextConfig } from './GlobalConfig';
import { useEffect, useState } from 'react';

// Modern redesign styles
import './redesign-2025.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import './App2.css'

import StNavbar from './components/StNavbar';
import StFooter from './components/StFooter';
import './theme-style.css';
import { SetSeo } from './lib/common_funcs';
import { storeUtm } from './lib/common_funcs';

function StLanding() {

	// Store the UTM parameters if passed
	storeUtm();

	const [copied, setCopied] = useState(false);

	const copyMcpConfig = () => {
		navigator.clipboard.writeText(TextConfig.mcpConfig.snippet);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	const scrollToMyRef = (id) => {
		var ref = document.getElementById(id);
		setTimeout(function () {

			 ref.scrollIntoView({
				 behavior: "smooth",
				 block: "start",
			 });
		}, 1000);
	};

	useEffect(() => {
		// Initialize AOS animations
		AOS.init({
			duration: 800,
			once: true,
			easing: 'ease-out-cubic',
			offset: 50
		});

		const anchor = window.location.hash.slice(1);

		if (anchor) {
			const anchorEl = document.getElementById(anchor);
			if (anchorEl) {
				scrollToMyRef(anchor);
			}
		}
	}, []);

	const homepageSeo = {
		title: "TurboSteed: AI-Driven Web Hosting for Claude Code & MCP Agents",
		description: "The hosting platform for AI coding agents. Build, manage, and deploy websites using Claude Code with MCP integration. CMS, forms, assets, and CDN included.",
		canonicalUrl: "https://turbosteed.com/",
		keywords: "AI hosting, Claude Code, MCP, web hosting, headless CMS, API-driven hosting",
		ogTitle: "TurboSteed: Your Agent Builds It. We Host It.",
		ogImage: "https://turbosteed.com/images/ts-social-share-home.jpg",
	}

	const schemaMarkup = {
		  "@context": "https://schema.org",
		  "@type": "WebSite",
		  "url": "https://turbosteed.com",
		  "name": "TurboSteed - AI-Driven Web Hosting"
	};

	const allParams = {
		"seo": homepageSeo,
		"schema": schemaMarkup
	}

	return (
		<div className="ts-redesign">

			{/* Call the Seo component at the top of the page component */}
			<SetSeo {...allParams} />

			<StNavbar />

			{/* Modern Hero Section - AI First */}
			<header id="home" className="ts-hero">
				{/* Animated gradient background */}
				<div className="ts-hero-bg">
					<div className="ts-gradient-orb ts-orb-1"></div>
					<div className="ts-gradient-orb ts-orb-2"></div>
					<div className="ts-gradient-orb ts-orb-3"></div>
				</div>

				{/* Grid pattern overlay */}
				<div className="ts-grid-pattern"></div>

				<div className="container ts-hero-content">
					<div className="row align-items-center">
						<div className="col-lg-6" data-aos="fade-right">
							<span className="ts-pill-badge">AI-Driven Web Hosting</span>
							<h1 className="ts-hero-title">
								<span className="ts-gradient-text">{TextConfig.heroTitle}</span>
							</h1>
							<p className="ts-hero-subtitle">{TextConfig.heroDescription}</p>
							<div className="ts-hero-cta">
								<a href={TextConfig.heroCta.primary.url} className="ts-btn ts-btn-primary">
									{TextConfig.heroCta.primary.text}
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14M12 5l7 7-7 7"/>
									</svg>
								</a>
								<a href={TextConfig.heroCta.secondary.url} className="ts-btn ts-btn-glass" target="_blank" rel="noopener noreferrer">
									{TextConfig.heroCta.secondary.text}
								</a>
							</div>
							<div className="ts-trust-badges">
								<span className="ts-works-with-badge">
									<i className="fa fa-check-circle"></i> {TextConfig.worksWithBadge}
								</span>
							</div>
						</div>
						<div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
							<div className="ts-mcp-config-card">
								<div className="ts-mcp-header">
									<span className="ts-mcp-title">{TextConfig.mcpConfig.headline}</span>
									<button className="ts-copy-btn" onClick={copyMcpConfig} title="Copy to clipboard">
										{copied ? (
											<>
												<i className="fa fa-check"></i> Copied
											</>
										) : (
											<>
												<i className="fa fa-clipboard"></i> Copy
											</>
										)}
									</button>
								</div>
								<pre className="ts-code-snippet"><code>{TextConfig.mcpConfig.snippet}</code></pre>
							</div>
						</div>
					</div>
				</div>
			</header>


			<main className="main-content d-block">

				{/* How It Works Section */}
				<section className="ts-section ts-section-light">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">How It <span className="ts-text-gradient">Works</span></h2>
							<p className="ts-section-subtitle">Get started in four simple steps</p>
						</header>

						<div className="ts-how-it-works-grid">
							{TextConfig.howItWorks.map((step, index) => (
								<div className="ts-step-card" key={step.step} data-aos="fade-up" data-aos-delay={index * 100}>
									<div className="ts-step-number">{step.step}</div>
									<h3>{step.title}</h3>
									<p>{step.description}</p>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* Personas Section */}
				<section id="personas" className="ts-section ts-section-gradient-1">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">TurboSteed is <span className="ts-text-gradient">ideal for</span></h2>
							<p className="ts-section-subtitle">Built for developers and agencies</p>
						</header>

						<div className="row g-4">
							{TextConfig.personas.map((persona, index) => (
								<div className="col-lg-6" key={persona.usecase} data-aos="fade-up" data-aos-delay={index * 100}>
									<div className="ts-persona-column">
										<div className="ts-persona-column-header">
											<i className={persona.icon + " fa-2x"} aria-hidden="true"></i>
											<h3>{persona.usecase}</h3>
										</div>
										<p className="ts-persona-description">{persona.persona}</p>
										{persona.features && (
											<ul className="ts-persona-features">
												{persona.features.map((feature, fIndex) => (
													<li key={fIndex}>
														<i className="fa fa-check text-success"></i>
														{feature}
													</li>
												))}
											</ul>
										)}
										{persona.cta && (
											<a href={persona.cta.url} className="ts-btn ts-btn-primary">
												{persona.cta.text}
												<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
													<path d="M5 12h14M12 5l7 7-7 7"/>
												</svg>
											</a>
										)}
									</div>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* Social Proof Section */}
				<section className="ts-section ts-section-dark">
					<div className="container">
						<div className="ts-social-proof" data-aos="fade-up">
							<h2 className="text-white mb-4">{TextConfig.socialProof.heading}</h2>
							<div className="ts-values-grid">
								{TextConfig.socialProof.values.map((item, index) => (
									<div className="ts-value-item" key={index}>
										<i className={item.icon}></i>
										<span>{item.text}</span>
									</div>
								))}
							</div>
						</div>
					</div>
				</section>

				{/* Platform Benefits Section */}
				<section className="ts-section ts-section-gradient-2">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">Ditch server headaches. <span className="ts-text-gradient">Deploy in seconds</span></h2>
							<p className="ts-section-subtitle">Perfect for freelancers, designers, and agencies</p>
						</header>

						<div className="row g-4 justify-content-center">
							<div className="col-md-5" data-aos="fade-up" data-aos-delay="100">
								<div className="ts-bento-card h-100">
									<div className="ts-bento-card-icon">
										<i className="fa fa-tv"></i>
									</div>
									<h3>No hardware or software management</h3>
									<p>We take care of managing hardware, storage, network, burst traffic and software.</p>
								</div>
							</div>

							<div className="col-md-5" data-aos="fade-up" data-aos-delay="200">
								<div className="ts-bento-card h-100">
									<div className="ts-bento-card-icon">
										<i className="fa fa-code"></i>
									</div>
									<h3>Build with your tools, host with us</h3>
									<p>Use Claude Code, your favorite framework, or plain HTML. Deploy via CLI or API.</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Bring Your Own AI Stack Section */}
				<section className="ts-section ts-section-light">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">Bring Your Own <span className="ts-text-gradient">AI Stack</span></h2>
							<p className="ts-section-subtitle">Choose your model, your tools — we handle the hosting</p>
						</header>

						<div className="row g-4 justify-content-center">
							<div className="col-lg-8" data-aos="fade-up">
								<div className="ts-byoas-card">
									<div className="ts-byoas-icons">
										<span>Claude</span>
										<span>Codex</span>
										<span>Figma MCP</span>
										<span>n8n</span>
									</div>
									<p>MCP lets you combine multiple vendors — Figma for design, Claude or Codex for code, n8n for automation. TurboSteed provides features and hosting under one roof.</p>
									<ul className="ts-feature-list">
										<li>No separate accounts for hosting, forms, analytics, CDN, CMS</li>
										<li>Automate your entire site lifecycle from your local environment</li>
										<li>One platform, any AI model</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Features Section */}
				<section id="features" className="ts-section ts-section-light">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">Key Platform <span className="ts-text-gradient">Features</span></h2>
							<p className="ts-section-subtitle">Everything you need to build and deploy websites</p>
						</header>
						<div className="ts-bento-grid">
							{TextConfig.benefits.map((benefit, index) => (
								<div key={benefit.feature} className="ts-bento-card" data-aos="fade-up" data-aos-delay={index * 100}>
									<div className="ts-bento-card-icon">
										<i className={benefit.icon}></i>
									</div>
									<h3>{benefit.feature}</h3>
									<p>{benefit.value}</p>
									<a className="ts-read-more" href={benefit.readmeUrl} aria-label={benefit['aria-label']} target="_blank" rel="noopener noreferrer">
										Read more
										<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<path d="M5 12h14M12 5l7 7-7 7"/>
										</svg>
									</a>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* Mobile App Section */}
				<section className="ts-section ts-section-gradient-1">
					<div className="container">
						<div className="ts-feature-showcase reverse" data-aos="fade-up">
							<div className="ts-feature-content">
								<h2>Client updates <span className="ts-text-gradient">without the client calls</span></h2>
								<p>Your clients get a mobile app with real-time stats and form submissions. You stay focused on building.</p>
								<span className="ts-experimental-badge">Experimental</span>

								<ul className="ts-feature-list">
									<li>Site owners check analytics themselves — no Monday morning emails</li>
									<li>Contact form submissions in their pocket</li>
									<li>Reduces support requests, increases client satisfaction</li>
								</ul>
								<a href="https://dashboard.turbosteed.com" className="ts-btn ts-btn-primary">
									Start Now
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14M12 5l7 7-7 7"/>
									</svg>
								</a>
							</div>

							<div className="ts-feature-image" data-aos="fade-right" data-aos-delay="200">
								<img src="AppDemo-v1.gif" alt="Mobile app for website" style={{maxWidth: '300px'}} />
							</div>
						</div>
					</div>
				</section>

				{/* Final CTA Section */}
				<section className="ts-section ts-section-dark ts-cta-section">
					<div className="container">
						<div className="ts-cta-content" data-aos="fade-up">
							<h2>Ready to get started?</h2>
							<p>Install the CLI and deploy your first site in minutes</p>

							<div className="ts-cli-install">
								<code>{TextConfig.cliInstall.command}</code>
								<a href={TextConfig.cliInstall.npmUrl} target="_blank" rel="noopener noreferrer" className="ts-npm-link">
									<i className="fa fa-external-link"></i>
								</a>
							</div>

							<div className="ts-cta-buttons">
								<a href="https://dashboard.turbosteed.com" className="ts-btn ts-btn-primary ts-btn-lg">
									Create Account
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14M12 5l7 7-7 7"/>
									</svg>
								</a>
								<a href="/contactus" className="ts-btn ts-btn-glass ts-btn-lg">
									Contact Us
								</a>
							</div>
						</div>
					</div>
				</section>

			</main>

			<StFooter />

			<script src="/assets/js/script.js"></script>
			<script src="/assets/js/page-min.js"></script>
			<script src="/assets/js/page.js"></script>

		</div>
	);
}

export default StLanding;
